import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTiktok } from 'react-icons/fa';
import { version } from '../../package.json';
import logoImage from '../assets/images/e-invitation_logo.png';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <Link to="/" className="footer-logo">
              <img src={logoImage} alt="E-Invitation Logo" className="footer-logo-icon" />
              <span className="footer-logo-text">E-Invitation</span>
            </Link>
            <p className="footer-tagline">by Logica Technology</p>
            <p>Create beautiful digital invitations for weddings, birthdays, christenings, and more!</p>
            <div className="footer-price">
              <span>Starting at</span>
              <strong>₱200 - ₱700</strong>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/invitations?category=wedding">Wedding Invitations</Link></li>
              <li><Link to="/invitations?category=birthday">Birthday Invitations</Link></li>
              <li><Link to="/invitations?category=christening">Christening Invitations</Link></li>
              <li><Link to="/invitations?category=corporate">Corporate Events</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/invitations">View Samples</Link></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><Link to="/book">Book Now</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Main Website</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Us</h4>
            <div className="footer-contact">
              <p><a href="mailto:sales@logicatechnology.com">sales@logicatechnology.com</a></p>
              <p><a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">logicatechnology.com</a></p>
            </div>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61585468153192" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook color="#1877F2" /></a>
              <a href="https://www.tiktok.com/@logicatechnology" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Logica Technology. All rights reserved.</p>
          <p className="footer-subtext">E-Invitation is a digital service by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">logicatechnology.com</a></p>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Notice</Link>
            <span className="footer-legal-sep">·</span>
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
          <p className="footer-version">v{version}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
